import React from "react";
import Header from "../Componentes/Header";
import Menu from "../Componentes/Menu";
import Footer from "../Componentes/Footer";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function SemanaBritania() {
  return (
    <div>
      <Header></Header>
      <Menu></Menu>
       
      <center>
       <h1>Semana Britannia School.</h1>
      <img src="https://britanniaschool.co.com/imagenes/2021/10/757bcbc5-2215-4da9-a3e1-24824919a531.jpg" />
      <img src="https://britanniaschool.co.com/imagenes/2021/10/4a58c3bb-0d3d-4de3-84a2-93f22d1c7da0-1024x576.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/a7847f70-727a-4c4f-9c1a-562faa13ef1e-1024x461.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/5b1ce089-2659-47aa-b0ea-54406b56aee6-1.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/3e3c86ac-54f2-453a-8dac-0d73f44ec57a-1.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/08c82d5a-200b-4389-b780-6669a0b60b2e.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/80420eca-5a91-4d1a-a069-da2545b83812-1152x1536.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/390e8516-aad7-41d1-8f4f-5fcc03d697d7-1152x1536.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/ce90260d-fc19-47f9-8a8d-43cb42c271b4.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/4c285196-95d5-43f8-b834-007ef6f07c47.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/581affad-99ec-40dd-8a07-16742fe7ae3b-1024x768.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/a478e212-3f31-4e1c-9466-106e717886cc.jpg" />

      <img src="https://britanniaschool.co.com/imagenes/2021/10/c227acb0-34f4-4709-996a-048e707f21a5.jpg" />

      </center>

      <br></br>

      

      <br></br>

      <Footer></Footer>
    </div>
  );
}
